module.exports = __webpack_public_path__ + "static/media/pic12.97e37ed9.jpg";